import * as React from 'react';
import { useParams } from 'react-router-dom';
import { useSession } from '@lendi/lala-react';
import { SimpleNavbar } from '@lendi/navbar';

import { URL_PARAM_APPLICATION_ID } from '@funnels/constants';
import { UseParams } from '@funnels/types';
import { datadogUtil, getDashboardUrl } from '@funnels/utils';

export function Navbar() {
  const { [URL_PARAM_APPLICATION_ID]: applicationId } = useParams<UseParams>();
  const session = useSession();
  const handleLogout = () => {
    session.logout();
  };

  return (
    <SimpleNavbar
      homeURL={getDashboardUrl(applicationId)}
      onLogout={handleLogout}
      showBookanAppointmentCta
      showTalkToExpertCta
      onException={(err: Error) => datadogUtil.addError(err)}
    />
  );
}
